/* @flow weak */
import ReactDOM from 'react-dom';

// ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠
// DEPRECATED USE lib/withWidth
// ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠ ⚠

const stack = [];

const NORMAL_SIZE = 'NORMAL_SIZE';

function _getComponentSize(component) {
  const element = ReactDOM.findDOMNode(component);

  if (element) {
    const ctor = component.constructor;
    if (ctor.XXSMALL && (element.offsetWidth <= ctor.XXSMALL)) {
      return ctor.XXSMALL;
    } else if (ctor.XSMALL && (element.offsetWidth <= ctor.XSMALL)) {
      return ctor.XSMALL;
    } else if (ctor.SMALL && (element.offsetWidth <= ctor.SMALL)) {
      return ctor.SMALL;
    } else if (ctor.MEDIUM && (element.offsetWidth <= ctor.MEDIUM)) {
      return ctor.MEDIUM;
    } else if (ctor.LARGE && (element.offsetWidth <= ctor.LARGE)) {
      return ctor.LARGE;
    }
  }

  return NORMAL_SIZE;
}

function _handleResize() {
  stack.forEach(component => {
    const size = _getComponentSize(component);
    if (component._responsiveSize === size) {
      return;
    }

    component._responsiveSize = size;
  });
}

/*
  Dependencies:
  The component should contain at least one of [SMALL, MEDIUM, LARGE] as
  attributes in its statics object. Their values should be numbers that
  represent the max-width of the component's size state.
*/
const ResponsiveMixin = {
  componentWillMount() {
    this._responsiveSize = NORMAL_SIZE;
  },

  componentDidMount() {
    if (stack.length === 0) {
      window.addEventListener('resize', _handleResize);
    }

    stack.push(this);

    // Set the actual inital size after it has mounted
    this._responsiveSize = _getComponentSize(this);
  },

  componentWillUnmount() {
    const index = stack.indexOf(this);
    if (index >= 0) {
      stack.splice(index, 1);

      if (stack.length === 0) {
        window.removeEventListener('resize', _handleResize);
      }
    }
  },

  hasResized() {
    _handleResize();
  },

  getComponentSize() {
    return this._responsiveSize;
  },

  isComponentSize(size) {
    return (this.getComponentSize() === size);
  },

  isComponentSizes(sizes) {
    return sizes.indexOf(this.getComponentSize()) > -1;
  },
};

export default ResponsiveMixin;



// WEBPACK FOOTER //
// ./src/components/mixins/ResponsiveMixin.js